<mat-card
  appearance="outlined"
  *ngIf="model"
  class="formProcess"
  fxLayout="column"
  fxLayoutAlign=" stretch"
  fxLayoutGap="16px">
  <app-show-state-grid-registration [id]="model?.id" [title]="title"></app-show-state-grid-registration>
  <app-show-create-update-data [createUpdateEntity]="model"></app-show-create-update-data>
  <!----- Header with all dem actions -->
  <app-detail-page-header-actions
    [model]="model"
    [user]="user"
    [actions]="actions"
    (onActionClickedEvent)="executeAction($event)">
    <app-show-errors [errorFormList]="errorFormList"></app-show-errors>
  </app-detail-page-header-actions>
</mat-card>
<app-hint-card
  *ngIf="pageHintAdaptionName | uiAdaptionVisible$ | async"
  [outlined]="true"
  [constrainToPage]="true">
  <h2 style="color: inherit">Ihr Netzbetreiber möchte Ihnen folgende Informationen zum Antrag mitteilen</h2>
  <div [innerHTML]="pageHintAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
</app-hint-card>
<div>
  <div style="text-align: center; padding-top: 10px">Mit * markierte Felder sind Pflichtfelder!</div>
</div>
<ng-template appGridRegistrationForm></ng-template>
<app-default-card fxLayout="column" fxLayoutAlign="end">
  <!-- Todo: Saubere Lösung implementieren -->
  <app-external-privacy-form-field [control]="privacyPolicyControl" />
  <br />
  <button mat-raised-button color="primary" (click)="submit()">Daten Absenden</button>
</app-default-card>
